const initialState = [];
const rooms = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_ROOMS': {
			const { rooms } = action.payload;

			return rooms;
		}

		case 'ADD_ROOM': {
			const { room } = action.payload;

			return [ ...state, room ];
		}

		case 'REMOVE_ROOM': {
			const { id } = action.payload;

			return state.filter((room) => room.id !== id);
		}

		case 'UPDATE_ROOM': {
			const { room } = action.payload;

			return state.map((el) =>
			{
				if (el.id !== room.id)
					return el;
				else
				{
					return room;
				}
			});
		}

		case 'JOIN_USER_TO_ROOM': {
			const { user, roomId } = action.payload;

			return state.map((el) =>
			{
				if (el.id !== roomId)
					return el;
				else
				{
					const { users } = el;

					if (users && !users.some((u) => u.id === user?.id))
					{
						return { ...el, users: [ ...users, user ] };
					}
					else
					{
						return { ...el, users: [ user ] };
					}
				}
			});
		}

		case 'REMOVE_USER_FROM_ROOM': {
			const { userId } = action.payload;

			return state.map((el) =>
			{
				const { users } = el;

				if (users)
				{
					return { ...el, users: users.filter((u) => u.id !== userId) };
				}

				return el;
			});
		}

		default:
			return state;
	}
};

export default rooms;
